import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useHistory } from "react-router-dom";

import { url } from "../../../services/constant";

import { useTheme, useLoyalty } from "../../../hooks";
import { logEvent } from "firebase/analytics";
import analytics from "../../../context/analytics";

//svgs
import {
  Curve,
  CurveOverImage,
  ExpandIcon,
  NewBackButton,
  Phone,
  RightArrow,
  Time as TimeIcon,
  VoiceIcon,
  CollapseIcon,
} from "../../../components/svgs";
import {
  Body,
  Children,
  MainHolder,
  StyledText,
} from "../../../components/common/basic";
import { BackButton, FeatureHeader } from "../../../components/common";

const faq = [
  {
    title: `What is Mashup & Win Promo?`,
    description: `The Mashup & Win promo is a purchase driven promo aimed at rewarding active users on the Pulse App in the month of November.`
  },
  {
    title: `How do I earn points?`,
    description: `Point-based usage (mashup data and voice usage only) driven promo targeted at Pulse subscribers on MTN network`
  },
  {
    title: `What are the Terms & Conditions?`,
    description: `www.pulse.mtn.com.gh/mashup&win/t&cs`
  },
  {
    title: `Do I have to subscribe to participate?`,
    description: `No subscription required, just mashup and earn points`
  },
  {
    title: `How are the points calculated?`,
    description: `Every 50 pesewas mashup on the Pulse App earns twenty (20) points. Simply mashup on the pulse app and be rewarded with points.`
  },
  {
    title: `How much points can be redeemed?`,
    description: `Build up a minimum of 2000 points. `
  },
  {
    title: `What can I redeem with built up points?`,
    description: `Shopping vouchers from KFC, Melcom, Shoprite and Potbelly Shack`
  },
  {
    title: `What is the value of 2000 Points?`,
    description: `GHC 50.00 voucher`
  },
  {
    title: `How many times can redemption be done?`,
    description: `Redeem in multiples of 2000 points depending on total points built on November 30, 2022`
  },
]

const MashupnWinFaq = () => {
  const { themeContext, theme } = useTheme();
  const { activeTheme } = themeContext;
  const {
    selectedLoyaltyData,
  } = useLoyalty();

  const { promoData: { tailImage } = {} } = selectedLoyaltyData || {};

  const history = useHistory();

  let themeColor = "background";
  let background = theme.colors[themeContext.activeTheme][themeColor];
  useEffect(() => {
    analytics().then(anl => logEvent(anl, "screen_view", {
      firebase_screen: "MashupAndWinFaq",
      firebase_screen_class: "MashupAndWinFaq",
    }));
  }, []);
  return (
    <>
      <MainHolder>
        <Children>
          <BackButton onClick={() => history.goBack()} />
          <FeatureHeader
            image={tailImage}
            title={["Frequently", "Asked", "Questions"]}
            background="#fff"
          />
          <Body>
            <div style={{ boxSizing: 'border-box', padding: '0 15px 30px 15px' }}>
              {
                faq.map(({ title, description }, idx) => (
                  <ExpandablePanel key={idx} title={title} color={background}>
                    <StyledText size={12} style={{ margin: 0, fontFamily: 'MTNRegular' }}>{description}</StyledText>
                  </ExpandablePanel>
                ))
              }
            </div>
          </Body>
        </Children>
      </MainHolder>
    </>
  );
};

const ExpandablePanel = ({ title, color, children }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  return (
    <div style={{ padding: '15px 0', borderBottom: '1px solid #B7BABA', cursor: 'pointer' }}>
      <div onClick={() => setIsExpanded(!isExpanded)} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <StyledText size={12} style={{ margin: 0 }} color={isExpanded ? color : '#000'}>{title}</StyledText>
        {
          isExpanded ?
            <div style={{ display: 'flex', alignItems: 'center' }}><CollapseIcon fill={color} /></div> :
            <div style={{ display: 'flex', alignItems: 'center' }}><ExpandIcon fill={color} /></div>}
      </div>
      {
        isExpanded && <div style={{ padding: '10px 0' }}>{children}</div>
      }
    </div>
  )
}


export default MashupnWinFaq;
